import { render } from "./TagModule.vue?vue&type=template&id=ef1b3590"
import script from "./TagModule.vue?vue&type=script&lang=js"
export * from "./TagModule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__